import React, { useEffect, useState } from 'react'
import {
  Base,
  Header,
  Text,
  Button,
  Link,
  PetPhoto,
  Modal,
  Loader,
} from '@pet-notify/ui'

import { FoundPet, Status } from 'types/found-pet'
import { useUpdateStatus } from 'hooks/found-pets'
import ButtonGroup from 'components/ButtonGroup'

type Props = {
  foundPet: FoundPet
}

function ContactInformationPage({ foundPet }: Props) {
  const updateStatusMutation = useUpdateStatus()

  const [petLocation, setPetLocation] = useState<{ latitude: number, longitude: number }>()

  useEffect(() => {
    if (foundPet?.pet?.meta?.location) {
      setPetLocation(foundPet.pet.meta.location)
    }
  }, [foundPet])

  function handleMarkPetAsSafe() {
    updateStatusMutation.mutate({
      status: Status.PET_IS_SAFE,
      token: foundPet.token,
    })
  }

  const [showMarkPetSafeConfirmation, setShowMarkPetSafeConfirmation] =
    useState(false)

  function handleConfirmMarkPetAsSafe() {
    setShowMarkPetSafeConfirmation(true)
  }
  function handleCancelMarkPetAsSafe() {
    setShowMarkPetSafeConfirmation(false)
  }
  return (
    <>
      <Header as='h1' size='xlarge' mb='8'>
        {foundPet.name} has found {foundPet.pet.name}
      </Header>

      {foundPet.pet.photo && (
        <PetPhoto
          alt={`Photo of ${foundPet.pet.name}`}
          src={foundPet.pet.photo.sizes.large.src}
        />
      )}

      <Base as='dl' className='pn-details' mb='6' style={{ marginBottom: '24px' }}>
        {foundPet.phone && (
          <div>
            <dt>Phone</dt>
            <dd>
              <Link href={`tel:${foundPet.phone}`}>{foundPet.phone}</Link>
            </dd>
          </div>
        )}

        {foundPet.email && (
          <div>
            <dt>Email</dt>
            <dd>
              <Link href={`mailto:${foundPet.email}`}>{foundPet.email}</Link>
            </dd>
          </div>
        )}

        {foundPet.alternateName && (
          <div>
            <dt>Alternate person to contact</dt>
            <dd>{foundPet.alternateName}</dd>
          </div>
        )}

        {foundPet.alternatePhone && (
          <div>
            <dt>Alternate phone</dt>
            <dd>
              <Link href={`tel:${foundPet.alternatePhone}`}>
                {foundPet.alternatePhone}
              </Link>
            </dd>
          </div>
        )}

        {foundPet.alternateEmail && (
          <div>
            <dt>Alternate email</dt>
            <dd>
              <Link href={`mailto:${foundPet.alternateEmail}`}>
                {foundPet.alternateEmail}
              </Link>
            </dd>
          </div>
        )}

        {foundPet.pickupInstructions && (
          <div>
            <dt>Pickup instructions</dt>
            <dd>{foundPet.pickupInstructions}</dd>
          </div>
        )}
      </Base>

      <div style={{ display: 'inline-flex', flexDirection: 'column', gap: '16px' }}>
        <Button as='a' href={`https://maps.google.com/?q=${petLocation?.latitude},${petLocation?.longitude}`} target='_blank'>
          Click here to see the pet's location
        </Button>

        <Button onClick={handleConfirmMarkPetAsSafe}>
          Confirm {foundPet.pet.name} is safe
        </Button>
      </div>


      {showMarkPetSafeConfirmation && (
        <Modal onClose={handleCancelMarkPetAsSafe} variant='small'>
          <Header as='h2' size='xlarge' mb='4'>
            Are you sure?
          </Header>
          <Text mb='4'>
            Once you mark your pet as safe, you won&apos;t be able to access the
            recovery information again.
          </Text>

          {updateStatusMutation.isLoading ? (
            <Loader />
          ) : (
            <ButtonGroup>
              <Button
                type='button'
                variant='hollow'
                onClick={handleCancelMarkPetAsSafe}
              >
                Cancel
              </Button>
              <Button type='button' onClick={handleMarkPetAsSafe}>
                Yes, I&apos;m sure
              </Button>
            </ButtonGroup>
          )}
        </Modal>
      )}
    </>
  )
}
export default ContactInformationPage
